import styled from 'styled-components';
import { MediaQueryBreakpoints } from '@rockalingua/ui';

export const Container = styled.div`
  display: flex;
  gap: 48px;
  padding: 48px;

  @media only screen and (max-width: ${MediaQueryBreakpoints.sm}px) {
    flex-direction: column;
    padding: 24px;
  }
`;

export const HeroContent = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;

  @media only screen and (max-width: ${MediaQueryBreakpoints.sm}px) {
    align-items: center;
  }
`;

export const VideoContainer = styled.div`
  padding-top: 24px;
  flex: 1;
`;
